import { FC, useState } from 'react';
import Dialog from 'src/modules/shared/components/molecules/dialog';
import { EditableAddressField } from 'src/modules/communications/components/molecules/contacts/editable-address-field';
import { ChannelType } from 'src/api/generated';
import { Typography } from '@material-tailwind/react';

interface InvalidPhoneDialogProps {
  isOpen: boolean;
  phoneNumber: string;
  onStopSession: () => void;
  onSkip: () => void;
  onSave: (newPhone: string) => Promise<void>;
}

export const InvalidPhoneDialog: FC<InvalidPhoneDialogProps> = ({
  isOpen,
  phoneNumber,
  onStopSession,
  onSkip,
  onSave,
}) => {
  const [isUpdating, setIsUpdating] = useState(false);

  const handleSave = async ({ address: newPhone }: { address: string }) => {
    setIsUpdating(true);
    try {
      await onSave(newPhone);
    } finally {
      setIsUpdating(false);
    }
  };

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onSkip}
      title="Número de teléfono inválido"
      description={
        <div className="flex flex-col gap-4 justify-center items-center">
          <Typography className="font-normal text-sm">
            {/* TODO: check when implementing i18n */}
            Edita y arregla el número para continuar, o sáltalo para continuar
            con el siguiente.
          </Typography>
          <EditableAddressField
            size="lg"
            address={phoneNumber}
            channelType={ChannelType.PHONE}
            onSave={handleSave}
            loading={isUpdating}
            // TODO: check when implementing i18n
            placeholder="Ingresa un número válido..."
          />
        </div>
      }
      // TODO: check when implementing i18n
      confirmLabel="Terminar sesión"
      cancelLabel="Saltar"
      onConfirm={onStopSession}
      variant="danger"
    />
  );
};
